import React from "react";
import { withShowIf } from "../../../../../../../../../../components/with-show-if/with-show-If.component";
import { Content, HostContainer } from "./flyer-detail-page-preview-position-details.styles";
import { FlyerDetailPagePreviewPositionDetailsProps } from "./flyer-detail-page-preview-position-details.props";
import { FlyerDetailPageTemplatePositionDetailsProduct } from "../flyer-detail-page-preview-position-details-product/flyer-detail-page-preview-position-details-product.component";
import { FlyerDetailPagePreviewSubcategoriesList } from "../flyer-detail-page-preview-position-subcategories-list/flyer-detail-page-preview-subcategories-list.component";
import {
  Products,
  ProductImages,
  ProductImg,
} from "./flyer-detail-page-preview-position-details.styles";
import { FlyerDetailPageDetailPositionLabel } from "../../styles/flyer-detail-page-preview-cell.styles";

export const FlyerDetailPagePreviewPositionDetails = withShowIf(
  (props: FlyerDetailPagePreviewPositionDetailsProps) => (
    <HostContainer onClick={props.onClick}>
      <Content>
        <FlyerDetailPageDetailPositionLabel>
          {props.templatePositionLabel}
        </FlyerDetailPageDetailPositionLabel>
        <ProductImages>
          {props.position.products.map((product, index) => (
            <ProductImg alt={`${product.name}`} src={product.image || ""} key={index} />
          ))}
        </ProductImages>

        <Products>
          <FlyerDetailPagePreviewSubcategoriesList
            categories={props.position.categoryDetails || []}
          />

          {props.position.products.map((product, index) => (
            <FlyerDetailPageTemplatePositionDetailsProduct
              flyerEndDatePassed={props.flyerEndDatePassed}
              product={product}
              copy={props.position.copies}
              language={props.language}
              key={index}
            />
          ))}
        </Products>
      </Content>
    </HostContainer>
  )
);
